import React, { useEffect, useState } from "react";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import VirtualTable from "../ui/VirtualTable";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { bm_date } from "../utils/Utils";
import Divider from "../ui/Divider";
import Space from "../ui/Space";
import Input from "../ui/Input";
import Label from "../ui/Label";
import TextArea from "../ui/TextArea";
import { ROUTES } from "../utils/Routes";
import Nav from "../ui/Nav";
import Spin from "../ui/Spin";

export default function OrderTrack(props) {

    const {
        callback = () => { },
        route = ROUTES.HISTORY.ORDER_TRACK,
    } = props;

    const [data, setData] = useState(props.data);
    const [selected, setSelected] = useState((data?.length > 0) ? data[0] : {})
    const [loading, setLoading] = useState(false);
    const row_key = "invoice_id";


    const updateRow = (_row) => {
        let _data = [...data];
        let _f = _data.findIndex(item => item?.[row_key] === _row?.[row_key]);
        if (_f > -1) {
            _data[_f] = _row;
            setSelected(_row);
            setData(_data);
        }
    }


    const updateTracking = (_selected = selected) => {
        setLoading(true);
        pubCall("shipment_tracking.update", { invoice_id: selected?.[row_key] }, (_s, _r) => {
            if (_s) {
                updateRow(_r);
                console.log(_r);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    const actions = [
        { key: KBD.ESCAPE, action: () => { callback(false) } },
        { key: KBD.U, text: "Update", action: () => { updateTracking(selected) } },
    ]

    useEffect(() => {

        if(loading){
            return; 
        }
        const cleanup = listen(route, actions, false, [KBD.ENTER]);
        return cleanup;
    }, [actions, selected, loading])


    useEffect(() => {
        window.bm_state.value = route;
    }, [])




    const columns = [
        { key: "quantity", title: <>Qty</>, align: "right", width: 35 },
        { key: "supplier", title: <>Sup</>, align: "left", width: 85 },
        {
            key: "tracking_number", title: <>Tracking #</>, align: "left", grow: true, width: 200
        },
        {
            key: "ship_date", title: <>Ship Date</>, align: "left", width: 100, render: (e) => {
                return bm_date(e)
            }
        },
        {
            key: "delivery_date", title: <>Expected Date</>, align: "left", width: 100, render: (e) => {
                return bm_date(e)
            }
        },

    ];




    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }

        const nextIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };
    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) - _rows;
        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };





    return (
        <Spin loading={loading}>
            <div style={{ "width": "672px" }}>

                <div className="shim" /> <div className="shim" />

                <Space>
                    <Label width={70}>Supplier</Label>
                    <Input width={270} value={selected?.supplier} />
                    <div>&nbsp;&nbsp;</div>
                    <Label width={80}>Invoice Date</Label>
                    <Input width={200} value={bm_date(selected?.invoice_date)} />
                </Space>
                <div className="shim" />
                <Space>
                    <Label width={70}>Carton#</Label>
                    <Input width={270} value={selected?.carton_number} />
                    <div>&nbsp;&nbsp;</div>
                    <Label width={80}>Invoice#</Label>
                    <Input width={200} value={selected?.invoice_number} />
                </Space>
                <div className="shim" />
                <Space>
                    <Label width={70}>Carrier</Label>
                    <Input width={270} value={selected?.carrier} />
                    <div>&nbsp;&nbsp;</div>
                    <Label width={80}>PackSlip#</Label>
                    <Input width={200} value={selected?.pack_slip_number} />
                </Space>
                <div className="shim" />
                <Space>
                    <Label width={70}>Tracking#</Label>
                    <Input width={270} value={selected?.tracking_number} />
                    <div>&nbsp;&nbsp;</div>
                    <Label width={80}>BOL</Label>
                    <Input width={200} value={selected?.bill_of_landing} />
                </Space>

                <div className="shim" />
                <Space>
                    <Label width={70}>Expected</Label>
                    <Input width={270} value={bm_date(selected?.delivery_date)} />
                    <div>&nbsp;&nbsp;</div>
                    <Label width={80}>Shipped</Label>
                    <Input width={200} value={bm_date(selected?.ship_date)} />
                </Space>

                 <div className="shim" />
                <Space>
                    <Label width={70}>Updated</Label>
                    <Input width={270} value={bm_date(selected?.last_update_date)} />
                    <div>&nbsp;&nbsp;</div>
                  
                </Space>


                <div className="shim" />
                <div className="shim" />
                <Space style={{ "alignItems": "start" }}>
                    <Label width={70}>Status</Label>
                    <TextArea style={{ "height": "50px", "whiteSpace": "wrap" }} width={587} rows={2} value={selected?.status} />
                </Space>
                <div className="shim" />
                <div className="shim" />
                <VirtualTable
                    onRowClick={(item, event, index) => { setSelected(item) }}
                    next={next}
                    scrollbar={true}
                    prev={prev}
                    align={"auto"}
                    row_key={row_key}
                    current={selected}
                    data={data}
                    columns={columns}
                    width={672}
                    height={200}
                    loading={false}
                    offset={0}
                    route={route}
                />
                <div className="shim" />
                <Nav nav={actions} />
            </div>
        </Spin>
    )
}